import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * A custom React hook that scrolls to the top of the page whenever the route changes.
 *
 * @remarks
 * This hook uses the `useLocation` hook from `react-router-dom` to access the current
 * pathname and scrolls to the top of the page whenever the pathname changes.
 */
function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}

export default useScrollToTop;
